module.exports = __webpack_public_path__ + "static/media/loading.be3e52bd.gif";